export interface AuthRequest {
  grant_type: "client_credentials";
  scope: string;
  client_id: string;
  client_secret: string;
  acr_values: string;
}
